import buildQuery from "odata-query";
import { request } from "services/request";

const resource = "api/timezones";
const query = { orderBy: ["utcOffset asc"] };

const list = () => request(`${resource}/get${buildQuery(query)}`, { method: "GET" });

const item = (id: string) =>
    request(`${resource}/get${buildQuery({ filter: { id } })}`, { method: "GET" }).then((data) => data[0]);

export { list, item };
